import { defineMessages } from 'react-intl';

export const headerMessages = defineMessages({
  addInTitle: {
    id: 'pptx-addin.header.add-in-title',
    defaultMessage: 'PowerPoint Add-in',
  },
  brandName: {
    id: 'pptx-addin.header.brand-name',
    defaultMessage: 'Showell',
  },
  signOut: {
    id: 'pptx-addin.header.sign-out',
    defaultMessage: 'Sign out',
  },
  accountMenu: {
    id: 'pptx-addin.header.account-menu',
    defaultMessage: 'Account menu',
  },
});

export const homeMessages = defineMessages({
  eyebrow: {
    id: 'pptx-addin.home.eyebrow',
    defaultMessage: 'Bring Slides In',
  },
  heroTitle: {
    id: 'pptx-addin.home.hero-title',
    defaultMessage: 'Browse presentations',
  },
  heroDescription: {
    id: 'pptx-addin.home.hero-description',
    defaultMessage:
      'Open a PowerPoint from Showell and append its slides into the deck you are editing.',
  },
  browseButton: {
    id: 'pptx-addin.home.browse-button',
    defaultMessage: 'Browse presentations',
  },
  hint: {
    id: 'pptx-addin.home.hint',
    defaultMessage: 'All files whose original format is PPTX are shown.',
  },
});

export const browseMessages = defineMessages({
  allFiles: {
    id: 'pptx-addin.browse.all-files',
    defaultMessage: 'All files',
  },
  home: {
    id: 'pptx-addin.browse.home',
    defaultMessage: 'Home',
  },
  libraryTitle: {
    id: 'pptx-addin.browse.library-title',
    defaultMessage: 'Showell Library',
  },
  browseTitle: {
    id: 'pptx-addin.browse.browse-title',
    defaultMessage: 'Browse presentations',
  },
  workspaceError: {
    id: 'pptx-addin.browse.workspace-error',
    defaultMessage: 'Workspace could not be resolved from identity.',
  },
  searchPlaceholder: {
    id: 'pptx-addin.browse.search-placeholder',
    defaultMessage: 'Search presentations...',
  },
  loading: {
    id: 'pptx-addin.browse.loading',
    defaultMessage: 'Loading...',
  },
  noResults: {
    id: 'pptx-addin.browse.no-results',
    defaultMessage: 'No presentations found',
  },
  openItem: {
    id: 'pptx-addin.browse.open-item',
    defaultMessage: 'Open {title}',
  },
  thumbnailAlt: {
    id: 'pptx-addin.browse.thumbnail-alt',
    defaultMessage: 'Thumbnail for {title}',
  },
  failedToLoad: {
    id: 'pptx-addin.browse.failed-to-load',
    defaultMessage: 'Failed to load files',
  },
});

export const commonMessages = defineMessages({
  back: {
    id: 'pptx-addin.common.back',
    defaultMessage: 'Go back',
  },
});

export const presentationMessages = defineMessages({
  loading: {
    id: 'pptx-addin.presentation.loading',
    defaultMessage: 'Loading slides...',
  },
  slideCount: {
    id: 'pptx-addin.presentation.slide-count',
    defaultMessage: '{count, plural, one {1 slide} other {{count} slides}}',
  },
  selectAll: {
    id: 'pptx-addin.presentation.select-all',
    defaultMessage: 'Select all',
  },
  slideAlt: {
    id: 'pptx-addin.presentation.slide-alt',
    defaultMessage: 'Slide {index}',
  },
  insertSuccess: {
    id: 'pptx-addin.presentation.insert-success',
    defaultMessage: 'Slides inserted successfully!',
  },
  insertButton: {
    id: 'pptx-addin.presentation.insert-button',
    defaultMessage:
      'Insert {count, plural, one {1 slide} other {{count} slides}}',
  },
  insertAll: {
    id: 'pptx-addin.presentation.insert-all',
    defaultMessage: 'Insert all slides',
  },
  clearSelection: {
    id: 'pptx-addin.presentation.clear-selection',
    defaultMessage: 'Clear selection',
  },
  errorNoUrl: {
    id: 'pptx-addin.presentation.error-no-url',
    defaultMessage: 'File URL not available',
  },
  errorDownload: {
    id: 'pptx-addin.presentation.error-download',
    defaultMessage: 'Failed to download presentation',
  },
  errorLoad: {
    id: 'pptx-addin.presentation.error-load',
    defaultMessage: 'Failed to load slide info',
  },
  errorImport: {
    id: 'pptx-addin.presentation.error-import',
    defaultMessage: 'Import failed. Please try again.',
  },
});

export const syncStatusMessages = defineMessages({
  resolving: {
    id: 'pptx-addin.sync-status.resolving',
    defaultMessage: 'Checking sync status...',
  },
  notSyncedTitle: {
    id: 'pptx-addin.sync-status.not-synced-title',
    defaultMessage: "This presentation isn't in your Showell files.",
  },
  notSyncedHint: {
    id: 'pptx-addin.sync-status.not-synced-hint',
    defaultMessage:
      "Changes won't be synced. Open the file from Showell to enable sync.",
  },
  synced: {
    id: 'pptx-addin.sync-status.synced',
    defaultMessage: 'Changes will be synced to Showell automatically.',
  },
  multipleInWorkspaceTitle: {
    id: 'pptx-addin.sync-status.multiple-in-workspace-title',
    defaultMessage:
      'This presentation matches multiple Showell files in this workspace.',
  },
  multipleInWorkspaceHint: {
    id: 'pptx-addin.sync-status.multiple-in-workspace-hint',
    defaultMessage:
      "Changes won't be synced. Remove duplicate references in Showell so we know which record to update.",
  },
});

export const loginMessages = defineMessages({
  title: {
    id: 'pptx-addin.login.title',
    defaultMessage: 'Showell Login',
  },
});

export const syncMessages = defineMessages({
  errorResolve: {
    id: 'pptx-addin.sync.error-resolve',
    defaultMessage: 'Failed to resolve current presentation in Showell.',
  },
});

export const workspaceMessages = defineMessages({
  eyebrow: {
    id: 'pptx-addin.workspace.eyebrow',
    defaultMessage: 'Workspace',
  },
  title: {
    id: 'pptx-addin.workspace.title',
    defaultMessage: 'Select workspace',
  },
  description: {
    id: 'pptx-addin.workspace.description',
    defaultMessage: 'Choose which Showell workspace to browse.',
  },
});

export const workspaceResolverMessages = defineMessages({
  openFromShowell: {
    id: 'pptx-addin.workspace-resolver.open-from-showell',
    defaultMessage:
      'Please open a presentation from Showell to use this add-in.',
  },
  resolutionError: {
    id: 'pptx-addin.workspace-resolver.resolution-error',
    defaultMessage: 'Failed to resolve workspace. Please try again.',
  },
  retry: {
    id: 'pptx-addin.workspace-resolver.retry',
    defaultMessage: 'Retry',
  },
  autoSwitchedWorkspace: {
    id: 'pptx-addin.workspace-resolver.auto-switched-workspace',
    defaultMessage: 'Switched to workspace: {name}',
  },
  ambiguousTitle: {
    id: 'pptx-addin.workspace-resolver.ambiguous-title',
    defaultMessage: 'This file is in multiple workspaces',
  },
  ambiguousDescription: {
    id: 'pptx-addin.workspace-resolver.ambiguous-description',
    defaultMessage: 'Pick the workspace you want to use for browsing slides.',
  },
});
